import { FunctionComponent } from 'react';
import styles from './EducatorNotFound.module.scss';
import Image from 'next/image';
import Link from 'next/link';
// @ts-ignore This fails type checking in CI because it's in the public folder
import NotFoundOwl from '../../../../public/404-owl.png';

export const EducatorNotFound: FunctionComponent = () => {
    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.textContent}>
                    <h1 className={styles.title}>Page Not Found</h1>
                    <p className={styles.subtitle}>
                        We couldn&apos;t find the page you&apos;re looking for.
                    </p>
                    <p className={styles.description}>
                        This business may have unpublished their profile, changed their URL, or the
                        link you followed may be outdated.
                    </p>

                    <ul className={styles.reasonsList}>
                        <li className={styles.reasonItem}>
                            <span className={styles.reasonIcon}>🔍</span>
                            <span className={styles.reasonText}>
                                The author may have unpublished their profile or courses
                            </span>
                        </li>
                        <li className={styles.reasonItem}>
                            <span className={styles.reasonIcon}>🔗</span>
                            <span className={styles.reasonText}>
                                The URL may contain a typo or be outdated
                            </span>
                        </li>
                        <li className={styles.reasonItem}>
                            <span className={styles.reasonIcon}>⏰</span>
                            <span className={styles.reasonText}>
                                The owner may have temporarily removed their content
                            </span>
                        </li>
                    </ul>

                    <p className={styles.description}>
                        Need help? Our{' '}
                        <a href="mailto:support@cademy.io" className={styles.supportLink}>
                            support team
                        </a>{' '}
                        is here to assist you with any questions or issues.
                    </p>
                </div>

                <div className={styles.imageContainer}>
                    <Image
                        src={NotFoundOwl}
                        alt="Page not found illustration"
                        width={280}
                        height={280}
                        className={styles.image}
                    />
                </div>
            </div>
        </div>
    );
};
